import React from "react";

const IconXLSX = ({ color = "#ff681c" }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M605 5110 c-11 -4 -31 -20 -45 -35 l-25 -27 0 -2489 0 -2489 33 -32
32 -33 1960 0 1960 0 32 33 33 32 3 2063 c1 1134 0 2073 -3 2087 -8 33 -838
867 -882 886 -27 12 -273 14 -1555 13 -838 0 -1532 -4 -1543 -9z m2933 -312
l-3 -83 -1382 -3 -1383 -2 0 85 0 85 1385 0 1386 0 -3 -82z m442 -293 l195
-195 -198 0 -197 0 0 195 c0 107 1 195 3 195 1 0 90 -88 197 -195z m-440 -190
c0 -169 7 -198 54 -229 22 -14 68 -16 391 -16 l365 0 0 -1915 0 -1915 -1790 0
-1790 0 0 2115 0 2115 1385 0 1385 0 0 -155z"
        />
        <path
          d="M2521.0786 1718.4814C2506.0416 1717.9377 2490.6951 1719.1265 
2475.2846 1722.2036L1597.6426 1897.7095C1476.6938 1921.9337 
1388.75 2029.1783 1388.75 2152.5088L1388.75 3589.4912C1388.75 
3712.7857 1476.7041 3820.1021 1597.6426 3844.2905L2475.2846 
4019.7964C2587.5699 4042.2387 2691.3938 3961.9506 2709.7813 
3852.75L3265.625 3852.75C3440.0169 3852.75 3583.25 3709.5169 3583.25 
3535.125L3583.25 2264.625C3583.25 2090.2331 3440.0169 1947 3265.625 
1947L2717 1947 2717 1920.3808C2717 1810.3635 2626.3375 1722.287 
2521.0786 1718.4814ZM2509.2354 1892.0698C2528.8254 1888.1582 2543.75 
1900.3539 2543.75 1920.3808L2543.75 3821.6192C2543.75 3841.6461 
2528.8086 3853.8543 2509.2354 3849.9302A86.6337 86.6337 90 002509.2354 
3849.8173L1631.7061 3674.3115A86.6337 86.6337 90 001631.5933 
3674.3115C1590.5397 3666.1184 1562 3631.3256 1562 3589.4912L1562 
2152.5088C1562 2110.6744 1590.6084 2075.8069 1631.7061 
2067.5758L2509.2354 1892.0698ZM2717 2120.25 3265.625 2120.25C3346.3726 
2120.25 3410 2183.8774 3410 2264.625L3410 3535.125C3410 3615.8726 
3346.3726 3679.5 3265.625 3679.5L2717 3679.5 2717 2120.25ZM2919.125 
2351.25A86.6337 86.6337 90 102919.125 2524.5L3150.125 2524.5A86.6337 
86.6337 90 103150.125 2351.25L2919.125 2351.25ZM1850.6372 
2475.8863C1833.9568 2475.4413 1816.9139 2479.8276 1801.7979 2489.4214 
1761.4884 2515.1201 1749.6504 2568.6148 1775.2914 2608.9819L1947.8648 
2880.1362 1775.2914 3151.2905C1749.6504 3191.6578 1761.4884 3245.1523 
1801.7979 3270.8511 1816.2354 3279.9756 1832.3296 3284.3862 1848.2686 
3284.3862 1876.8547 3284.3862 1904.9546 3270.2745 1921.4711 
3244.3447L2050.5063 3041.543 2179.5415 3244.2319C2196.1158 3270.1618 
2224.1579 3284.3862 2252.7442 3284.3862 2268.6832 3284.3862 
2284.6646 3280.0911 2299.1021 3270.8511 2339.4116 3245.1523 2351.3622 
3191.5451 2325.7212 3151.1777L2153.2608 2880.1362 2325.7212 
2609.0947C2351.3622 2568.7275 2339.4116 2515.1201 2299.1021 2489.4214 
2258.8503 2463.7804 2205.2979 2475.6155 2179.5415 2516.0405L2050.5063 
2718.7295 1921.4711 2515.9277C1905.4095 2490.6621 1878.4378 2476.6278 
1850.6372 2475.8863ZM2919.125 2813.25A86.6337 86.6337 90 102919.125 
2986.5L3150.125 2986.5A86.6337 86.6337 90 103150.125 2813.25L2919.125 
2813.25ZM2919.125 3275.25A86.6337 86.6337 90 102919.125 3448.5L3150.125 
3448.5A86.6337 86.6337 90 103150.125 3275.25L2919.125 3275.25Z"
        />
        <path style={{ transform: "scaleY(-1)", transformOrigin: "2560px 1024px" }} 
          d="M980 1408.656 1334.304 931.216 1021.984 492.432 1166.368 492.432 
1332.512 727.44Q1384.48 800.656 1406.24 840.08 1436.96 789.904 1478.688 
735.632L1663.008 492.432 1795.104 492.432 1473.056 924.304 1819.936 
1408.656 1669.92 1408.656 1439.264 1082Q1420.064 1053.84 1399.328 
1020.56 1368.864 1070.736 1355.552 1089.424L1125.664 1408.656 980 
1408.656ZM1921.824 1408.656 1921.824 492.432 2043.168 492.432 2043.168 
1300.624 2494.496 1300.624 2494.496 1408.656 1921.824 1408.656ZM2597.408 
1114.256 2711.84 1104.272Q2720.032 1173.136 2749.728 1217.168 2779.424 
1261.2 2841.888 1288.336 2904.352 1315.728 2982.432 1315.728 3051.808 
1315.728 3105.056 1294.992 3158.048 1274.256 3184.16 1238.416 3210.016 
1202.576 3210.016 1160.08 3210.016 1116.816 3184.928 1084.56 3160.096 
1052.56 3102.496 1030.544 3065.632 1016.208 2939.424 986 2813.216 
955.536 2762.528 928.656 2696.992 894.352 2664.736 843.408 2632.48 
792.464 2632.48 729.488 2632.48 660.112 2671.904 599.696 2711.328 
539.28 2786.848 508.048 2862.624 476.816 2955.04 476.816 3056.928 
476.816 3134.752 509.584 3212.576 542.608 3254.304 606.352 3296.288 
670.096 3299.36 750.736L3183.136 759.44Q3173.664 672.4 3119.648 628.112 
3065.632 583.824 2959.904 583.824 2850.08 583.824 2799.648 624.016 
2749.472 664.464 2749.472 721.296 2749.472 770.704 2785.056 802.448 
2820.128 834.448 2967.84 867.728 3115.552 901.264 3170.592 926.352 
3250.72 963.216 3288.864 1019.792 3326.752 1076.368 3326.752 1150.096 
3326.752 1223.056 3285.024 1287.824 3243.04 1352.592 3164.704 1388.432 
3086.368 1424.272 2988.064 1424.272 2863.648 1424.272 2779.68 1388.176 
2695.712 1351.824 2647.84 1279.12 2599.968 1206.16 2597.408 
1114.256ZM3399.456 1408.656 3753.76 931.216 3441.184 492.432 3585.568 
492.432 3751.968 727.44Q3803.68 800.656 3825.696 840.08 3856.16 789.904 
3898.144 735.632L4082.464 492.432 4214.304 492.432 3892.512 924.304 
4239.392 1408.656 4089.376 1408.656 3858.72 1082Q3839.264 1053.84 
3818.784 1020.56 3788.064 1070.736 3775.008 1089.424L3545.12 1408.656 
3399.456 1408.656Z"
        />      
      </g>
    </svg>
  );
};

export default IconXLSX;
